import {
  ActivityPriceBreakdown,
  ActivityShopResponse,
  ExperienceBookableItem,
  IExperiencesPassengerCounts,
  IPerson,
  PersonId,
  RestrictedToProductsEnum,
  RewardsAccount,
  SessionInfo,
  TrackingProperties,
  Experiment,
  ITrackingProperties,
  ActivitiesDetailsProperties,
  OpaqueToken,
} from "redmond";
import {
  IContactInfo,
  ParentState,
  getCartInitialContext,
  getIntialWalletContext,
  getInitialRewardsPaymentContext,
  getCartFulfillInitialContext,
} from "@capone/checkout";

import { ActivityMachineContext } from "./types";

import { getInitialAdditionalDetailsContext } from "../../../checkout";

export const getInitialActivityMachineContext = (
  activityShop?: ActivityShopResponse,
  priceBreakdown?: ActivityPriceBreakdown,
  travelerCounts?: IExperiencesPassengerCounts,
  rewardsAccounts?: RewardsAccount[],
  shopOptionTrackingProperties?: TrackingProperties,
  activityDetailsTrackingProperties?: ITrackingProperties<ActivitiesDetailsProperties>,
  channel?: "TravelApp" | "Mobile" | "Web",
  experiments?: Experiment[],
  opaqueProductToken?: OpaqueToken,
  selectedBookableItem?: ExperienceBookableItem | null,
): ActivityMachineContext => ({
  ...getCartInitialContext(),
  platform: "desktop",
  sessionInfo: {} as SessionInfo,
  activityShop,
  priceBreakdown,
  travelerCounts,
  selectedBookableItem,
  shopOptionTrackingProperties,
  activityDetailsTrackingProperties,
  [ParentState.activityTravelerInformation]: {
    selectedTravelerIds: [] as Array<PersonId>,
    userTravelers: [] as Array<IPerson>,
    visited: false,
    isValidated: false,
  },
  [ParentState.contactInformation]: {
    contactInfo: {} as IContactInfo,
    visited: false,
  },
  [ParentState.activityPrimaryTraveler]: {
    selectedPrimaryTravelerId: undefined,
  },
  [ParentState.activityAdditionalDetails]: {
    ...getInitialAdditionalDetailsContext(activityShop, priceBreakdown),
  },
  [ParentState.review]: {
    visited: false,
  },
  [ParentState.rewardsPayment]: {
    ...getInitialRewardsPaymentContext(),
    rewardsAccounts,
  },
  [ParentState.wallet]: {
    ...getIntialWalletContext(),
    applicableProduct: RestrictedToProductsEnum.Activities,
  },
  [ParentState.cardPayment]: {
    paymentMethods: [],
    selectedPaymentMethodId: undefined,
    spreedlyToken: undefined,
    error: undefined,
    visited: false,
  },
  [ParentState.bookingConfirmation]: {},
  [ParentState.cartFulfill]: {
    ...getCartFulfillInitialContext(),
    channel,
  },
  experiments,
  [ParentState.opaqueProductToken]: opaqueProductToken,
  [ParentState.productPricing]: priceBreakdown?.totalPriceWithFees,
});
